import { ModelBase, NormalString, Property, Required, VeryShortString } from '@skylab-shared/core';

export class UnitModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    public default: boolean;

    @Property(String, { nullable: true })
    public externalId: string | null;

    @Property()
    @NormalString('data-model.unit.validation.name.length')
    @Required('data-model.unit.validation.name.no-empty')
    public name: string;

    @Property()
    @VeryShortString('data-model.unit.validation.symbol.length')
    @Required('data-model.unit.validation.symbol.no-empty')
    public symbol: string;
}
